import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { capFirstChar } from './utilities';

export const setCommandTitle = (command, device) => {
	let title;
	const _format = get(format);
	switch (command) {
		case 'enableBeacon':
			title = _format('beacon_enabled', { default: 'Beacon enabled' });
			break;
		case 'disableBeacon':
			title = _format('beacon_disabled', { default: 'Beacon disabled' });
			break;
		case 'enableBuzzer':
			title = _format('buzzer_enabled', { default: 'Buzzer enabled' });
			break;
		case 'disableBuzzer':
			title = _format('buzzer_disabled', { default: 'Buzzer disabled' });
			break;
		case 'enableMotionLed':
			title = _format('motion_led_enabled', {
				default: 'Motion LED enabled',
			});
			break;
		case 'disableMotionLed':
			title = _format('motion_led_disabled', {
				default: 'Motion LED disabled',
			});
			break;
		case 'enableMeasureVibration':
			title = _format('measure_vibration_enabled', {
				default: 'Movement/vibration measurements enabled',
			});
			break;
		case 'disableMeasureVibration':
			title = _format('measure_vibration_disabled', {
				default: 'Movement/vibration measurements disabled',
			});
			break;
		case 'encrypt':
			title = _format('toast_title_device_encrypted', {
				default: 'device encrypted!',
				values: { device_name: device.name },
			});
			break;
		case 'decrypt':
			title = _format('toast_title_device_decrypted', {
				default: 'device decrypted!',
				values: { device_name: device.name },
			});
			break;
		case 'enableFahrenheit':
			title = _format('farenheit_enabled', {
				default: 'Fahrenheit enabled',
			});
			break;
		case 'disableFahrenheit':
			title = _format('farenheit_disabled', {
				default: 'Fahrenheit disabled',
			});
			break;
		case 'enableInvertDisplay':
			title = _format('invert_display_enabled', {
				default: 'Invert display enabled',
			});
			break;
		case 'disableInvertDisplay':
			title = _format('invert_display_disabled', {
				default: 'Invert display disabled',
			});
			break;
		case 'enablePowerSaver':
			title = _format('power_saver_enabled', {
				default: 'Power saver enabled',
			});
			break;
		case 'disablePowerSaver':
			title = _format('power_saver_disabled', {
				default: 'Power saver disabled',
			});
			break;
		case 'enableClockSync':
			title = _format('clock_sync_enabled', {
				default: 'Clock sync enabled',
			});
			break;
		case 'disableClockSync':
			title = _format('clock_sync_disabled', {
				default: 'Clock sync disabled',
			});
			break;
		case 'enableZigbee':
			title = _format('zigbee_enabled', { default: 'Zigbee enabled' });
			break;
		case 'disableZigbee':
			title = _format('zigbee_disabled', { default: 'Zigbee disabled' });
			break;
		default:
			title = _format('setting_scc_saved_toast', {
				default: 'Setting saved successfully.',
			});
			break;
	}
	return capFirstChar(title);
};
